import { UserBrowser } from '@home-diy-toolbox/web/analytics';

export const checkIsMobile = () => {
	const { FormFactor } = UserBrowser.get();
	const isMobile = FormFactor === 'Mobile' || FormFactor === 'Tablet';
	return isMobile;
};
